import React, {
  useState,
  useEffect,
  useRef,
  forwardRef,
  useImperativeHandle,
} from "react";
import {
  Flex,
  Box,
  Image,
  Spacer,
  Text,
  Checkbox,
  Button,
  SimpleGrid,
  Divider,
  Textarea,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import PrimaryButton from "../../components/primary-button";
import PrimaryButtonIcon from "../../components/primary-button-icon";
import { COLORS } from "../styles/colors";

import DynamicModal from "../../components/dynamic-modal";
import { UpdateAppointmentStatus } from "../../middleware/services/visits/patient-overview";
import DatePicker from "../date-picker";
import { fetchReferredDoctorUsers, fetchReferredHospital, updateDoctorNotes, updateTaskComplete } from "../../middleware/services/visits/patient-overview/updatedoctornotes";
import PrimaryInput from "../primary-input";
import EndVisitDynamicModal from "../patient-health/doctor-notes/end-visit-modal";
import moment from "moment";
import { actionAccessMain, getLoginID, useScreenType } from "../../auth";
import DropdownInput from "../dropdown-input";
import DropdownInputForVitals from "../dropdown-input-forVitals/index (3)";

const PatientVisitNav = forwardRef(
  (
    {
      patientName,
      patientImage,
      patientInfoId,
      subHeader,
      pateintId,
      doctorId,
      appointmentId,
      hasImage,
      time,
      showLoader,
      dismissLoader,
      showSuccessToast,
      showErrorToast,
      virtualVisit,
      IsAssign,
    },
    ref
  ) => {
    const [runningTime, setRunningTime] = useState("00:00:00");
    const [isRunning, setIsRunning] = useState(false);
    const timerRef = useRef(null);
    const totalSeconds = useRef(0);
    const navigate = useNavigate();
    const pauseOrEndVisit = useRef();
    const interruptVisit = useRef();

    // other options in end visit
    const options = [
      { id: 1, text: "ECG", row: 1 },
      { id: 2, text: "LABs", row: 1 },
      { id: 3, text: "IV Fluids", row: 1 },
      { id: 4, text: "Nebulizations", row: 2 },
      { id: 5, text: "MOT Procedures", row: 2 },
      { id: 6, text: "Other Minor OT", row: 2 },
      { id: 7, text: "IP Cases", row: 3 },
      { id: 8, text: "Physiotherapy Care", row: 3 },
      { id: 9, text: "Ambulance Service", row: 3 },
      { id: 10, text: "Injectibles for Seasonal Diseases", row: 4 },
      { id: 11, text: "Nutrition packs for pregnant women", row: 4 },
      { id: 12, text: "USG Scanning for Ante Natal/others", row: 4 },
      { id: 13, text: "Referral to Higher Centers"},
    ];
    const [checkedItems, setCheckedItems] = useState({});

    // Add these states at the top of your component
const [currentVisitType, setCurrentVisitType] = useState(() => {
  const currentUrl = window.location.href;
  return currentUrl.includes('/startvisit') ? 'advanced' : 'quick';
});

const [buttonText, setButtonText] = useState(() => {
  const currentUrl = window.location.href;
  return currentUrl.includes('/startvisit') ? 'Quick Rₓ' : 'Advanced Rₓ';
});

// Update the useEffect to properly detect the current page
useEffect(() => {
  const currentUrl = window.location.href;
  
  if (currentUrl.includes('/startvisit')) {
    setCurrentVisitType('advanced');
    setButtonText('Quick Rₓ');
  } else if (currentUrl.includes('/quickvisit')) {
    setCurrentVisitType('quick');
    setButtonText('Advanced Rₓ');
  }
}, []);

// Handler function for button click - FIXED
const handleRxButtonClick = () => {
  if (currentVisitType === 'advanced') {
    // Currently in advanced visit (/startvisit), navigate to quick (/quickvisit)
    navigate(`/quickvisit?doctorId=${doctorId}&patientId=${pateintId}&appointmentId=${appointmentId}`);
  } else {
    // Currently in quick visit (/quickvisit), navigate to advanced (/startvisit)
    navigate(`/startvisit?doctorId=${doctorId}&patientId=${pateintId}&appointmentId=${appointmentId}`);
  }
};

    const handleCheckboxChange = (id) => {
      // setCheckedItems((prev) => ({
      //   ...prev,
      //   [id]: !prev[id],
      // }));

      setCheckedItems((prev) => {
        const updatedCheckedItems = { ...prev, [id]: !prev[id] };
    
        // If option 13 is unchecked, reset referralCenter state
        if (id === 13 && !updatedCheckedItems[id]) {
          setReferralCenter(null);
        }
    
        // console.log("updatedCheckedItems", updatedCheckedItems);
        return updatedCheckedItems;
      });
    };

    // Follow Up Code
    const endVisitFollowUp = useRef();
    const [isScheduleFollowUp, setIsScheduleFollowUp] = useState(false);
    const [Esign, setEsign] = useState(false);
    const [CompleteDescription, setCompleteDescription] = useState(null);
    const [followUpDate, setFollowUpDate] = useState("");
    const [referralCenter, setReferralCenter] = useState("");
    const [referralDoctor, setReferralDoctor] = useState("");
    const [referralHospitalList, setReferralHospitalList] = useState([]);
    const [referralUsersList, setReferralUsersList] = useState([]);
    const [isFreeVisit, setIsFreeVisit] = useState(false);
    const screenType = useScreenType();

    const [actionAccessAppointments, setActionAccessAppointments] =
      useState(null);
    const handlePreviewClick = () => {
      const data = {
        followUpDate: isScheduleFollowUp
          ? followUpDate
            ? moment(followUpDate).format("D MMM YYYY")
            : ""
          : "",
        referraldoctor: referralDoctor && referralCenter ? `${referralDoctor}, ${referralCenter}` : referralDoctor || referralCenter,
      };
      endVisitFollowUp.current.openSecondModal(data);
    };

    const handlePauseEndClick = () => {
      // The referral doctor and followup date states can be reset here, if required in future
      // console.log("isAssig: ", IsAssign)
      FetchHospitals()
      FetchDoctorUsers()
      endVisitFollowUp.current.openModal();
    };

    const [interruptUrl, setInterruptUrl] = useState(null);

    const openInterruptModalWithUrl = (url) => {
      setInterruptUrl(url);
      if (interruptVisit.current) {
        FetchDoctorUsers()
        interruptVisit.current.openModal(url);
      }
    };
    useEffect(() => {
      setActionAccessAppointments(actionAccessMain(15));
      if (time && time !== "null") {
        const [hours, minutes, seconds] = time.split(":").map(Number);
        totalSeconds.current = hours * 3600 + minutes * 60 + seconds;
        setRunningTime(time);
      } else {
        totalSeconds.current = 0;
        setRunningTime("00:00:00");
      }
      return () => {
        if (timerRef.current) {
          clearInterval(timerRef.current);
        }
      };
    }, [time]);

    useImperativeHandle(ref, () => ({
      start() {
        if (!isRunning) {
          setIsRunning(true);
          timerRef.current = setInterval(() => {
            totalSeconds.current += 1;
            const hours = String(
              Math.floor(totalSeconds.current / 3600)
            ).padStart(2, "0");
            const minutes = String(
              Math.floor((totalSeconds.current % 3600) / 60)
            ).padStart(2, "0");
            const seconds = String(totalSeconds.current % 60).padStart(2, "0");
            setRunningTime(`${hours}:${minutes}:${seconds}`);
          }, 1000);
        }
      },
      pause() {
        handlePauseVisit();
      },
      resume() {
        if (!isRunning) {
          setIsRunning(true);
          timerRef.current = setInterval(() => {
            totalSeconds.current += 1;
            const hours = String(
              Math.floor(totalSeconds.current / 3600)
            ).padStart(2, "0");
            const minutes = String(
              Math.floor((totalSeconds.current % 3600) / 60)
            ).padStart(2, "0");
            const seconds = String(totalSeconds.current % 60).padStart(2, "0");
            setRunningTime(`${hours}:${minutes}:${seconds}`);
          }, 1000);
        }
      },
      end() {
        handleEndVisit();
      },

      openInterruptModalWithUrl,
    }));

    const handlePauseVisit = async () => {
      if (isRunning) {
        setIsRunning(false);
        if (timerRef.current) {
          clearInterval(timerRef.current);
        }

        const inputForPause = {
          input: {
            doctorid: doctorId,
            appointmentid: appointmentId,
            type: "pause",
            time: new Date().toISOString(), // current timestamp
          },
        };

        try {
          showLoader();
          const result = await UpdateAppointmentStatus(inputForPause.input);
          if (result.output.result === "Successfully Inserted") {
            showSuccessToast("Visit paused successfully");
            pauseOrEndVisit.current.closeModal();
            navigate(
              `/visitdetails?patientId=${pateintId}&appointmentId=${appointmentId}`
            );
          } else {
            showErrorToast("Something went wrong!");
          }
        } catch (error) {
          console.error("Error pausing visit:", error);
          showErrorToast("An error occurred while pausing visit");
        } finally {
          dismissLoader();
        }
      }
    };

    const handlePauseVisitViaInterrupt = async () => {
      if (isRunning) {
        setIsRunning(false);
        if (timerRef.current) {
          clearInterval(timerRef.current);
        }

        const inputForPause = {
          input: {
            doctorid: doctorId,
            appointmentid: appointmentId,
            type: "pause",
            time: new Date().toISOString(), // current timestamp
          },
        };

        try {
          showLoader();
          const result = await UpdateAppointmentStatus(inputForPause.input);
          if (result.output.result === "Successfully Inserted") {
            showSuccessToast("Visit paused successfully");
            pauseOrEndVisit.current.closeModal();
            // navigate(
            //   `/visitdetails?patientId=${pateintId}&appointmentId=${appointmentId}`
            // );
            navigate(interruptUrl);
          } else {
            showErrorToast("Something went wrong!");
          }
        } catch (error) {
          console.error("Error pausing visit:", error);
          showErrorToast("An error occurred while pausing visit");
        } finally {
          dismissLoader();
        }
      }
    };

    const handleInterruptPauseVisit = async () => {
      // console.log("clicked");
      if (isRunning) {
        setIsRunning(false);
        if (timerRef.current) {
          clearInterval(timerRef.current);
        }

        const inputForPause = {
          input: {
            doctorid: doctorId,
            appointmentid: appointmentId,
            type: "pause",
            time: new Date().toISOString(), // current timestamp
          },
        };

        try {
          showLoader();
          const result = await UpdateAppointmentStatus(inputForPause.input);
          if (result.output.result === "Successfully Inserted") {
            showSuccessToast("Visit paused successfully");
            interruptVisit.current.closeModal();
            navigate(interruptUrl);
          } else {
            showErrorToast("Something went wrong!");
          }
        } catch (error) {
          console.error("Error pausing visit:", error);
          showErrorToast("An error occurred while pausing visit");
        } finally {
          dismissLoader();
        }
      }
    };

    const handleSaveAsDraft = async () => {
      if (isRunning) {
        setIsRunning(false);
        if (timerRef.current) {
          clearInterval(timerRef.current);
        }

        const inputForDraft = {
          input: {
            doctorid: doctorId,
            appointmentid: appointmentId,
            type: "pause",
            time: new Date().toISOString(), // current timestamp
            savedasdraft: 1,
          },
        };

        // console.log(inputForDraft);

        try {
          showLoader();
          const result = await UpdateAppointmentStatus(inputForDraft.input);
          if (result.output.result === "Successfully Inserted") {
            showSuccessToast("Draft Saved successfully");
            pauseOrEndVisit.current.closeModal();
            navigate(
              `/visitdetails?patientId=${pateintId}&appointmentId=${appointmentId}`
            );
          } else {
            showErrorToast("Something went wrong!");
          }
        } catch (error) {
          console.error("Error saving draft:", error);
          showErrorToast("An error occurred while pausing visit");
        } finally {
          dismissLoader();
        }
      }
    };

    const handleInterruptSaveAsDraft = async () => {
      if (isRunning) {
        setIsRunning(false);
        if (timerRef.current) {
          clearInterval(timerRef.current);
        }

        const inputForDraft = {
          input: {
            doctorid: doctorId,
            appointmentid: appointmentId,
            type: "pause",
            time: new Date().toISOString(), // current timestamp
            savedasdraft: 1,
          },
        };

        // console.log(inputForDraft);

        try {
          showLoader();
          const result = await UpdateAppointmentStatus(inputForDraft.input);
          if (result.output.result === "Successfully Inserted") {
            showSuccessToast("Draft Saved successfully");
            interruptVisit.current.closeModal();
            navigate(interruptUrl);
          } else {
            showErrorToast("Something went wrong!");
          }
        } catch (error) {
          console.error("Error saving draft:", error);
          showErrorToast("An error occurred while pausing visit");
        } finally {
          dismissLoader();
        }
      }
    };

    const handlePrintOrder = () => {
      const url = `/visitprescription?doctorId=${doctorId}&patientId=${pateintId}&appointmentId=${appointmentId}`;
      window.open(url, "_blank");
    };

    const handleProgresNotesClick = () => {
      // const url = `/visitsummary?doctorId=${doctorId}&patientId=${pateintId}&appointmentId=${appointmentId}&fromEndVisit=true`;
      const url = `/visitsummary?doctorId=${doctorId}&patientId=${pateintId}&appointmentId=${appointmentId}`;
      window.open(url, "_blank");
    };

    const handleEndVisit = async () => {
      if (isRunning) {
        setIsRunning(false);
        if (timerRef.current) {
          clearInterval(timerRef.current);
        }

        const inputForEnd = {
          input: {
            doctorid: doctorId,
            appointmentid: appointmentId,
            type: "end",
            time: new Date().toISOString(), // current timestamp
          },
        };

        try {
          // showLoader();

          // console.log("change status to end", inputForEnd);
          const result = await UpdateAppointmentStatus(inputForEnd.input);
          if (result.output.result === "Successfully Inserted") {
            // showSuccessToast("Visit ended successfully");
          } else {
            showErrorToast("Something went wrong!");
          }
        } catch (error) {
          console.error("Error ending visit:", error);
          showErrorToast("An error occurred while ending visit");
        } finally {
          // dismissLoader();
        }
      }
    };

    const sendFollowUp = async () => {
      const dynamicKeys = options.reduce((acc, option) => {
        const formattedKey = option.text
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, "") // Create key from `text`, e.g., "ECG" -> "ecg"
          .replace(/[\s]+/g, ""); // Handle edge cases like multiple spaces
        acc[formattedKey] = checkedItems[option.id] ? 1 : 0;
        return acc;
      }, {});
      const inputToFollowUp = {
        input: {
          patientid: pateintId,
          doctorid: doctorId,
          appointmentid: appointmentId,
          appointmentenddate: new Date().toISOString(), // current timestamp
          completed: "3",
          followup: {
            isfollowup: isScheduleFollowUp ? 1 : 0,
            followupdate:
              isScheduleFollowUp && followUpDate
                ? moment(followUpDate).format("YYYY-MM-DD")
                : null,
            isfreevisit: isFreeVisit ? 1 : 0,
            referraldoctor: referralDoctor && referralCenter ? `${referralDoctor}, ${referralCenter}` : referralDoctor || referralCenter,
            ...dynamicKeys, // Add dynamic keys based on `options` and `checkedItems`
          },
        },
      };

      try {
        showLoader();
        console.log("follow up", inputToFollowUp);
        handleEndVisit(); // update the appointment status
        const result = await updateDoctorNotes(inputToFollowUp.input);
        console.log(result);
        if (result) {
          showSuccessToast("Follow-up information sent successfully");
          // Open prescription page in a new tab before redirecting to visits
          const url = `/visitprescription?doctorId=${doctorId}&patientId=${pateintId}&appointmentId=${appointmentId}&fromEndVisit=${true}&isSigned=${Esign}`;
          const url2 = `/visitsummary?doctorId=${doctorId}&patientId=${pateintId}&appointmentId=${appointmentId}&fromEndVisit=${true}`;
          window.open(url, "_blank");
          // window.open(url2, "_blank");
          navigate("/visits");
        } else {
          showErrorToast("Something went wrong!");
        }
      } catch (error) {
        console.error("Error in sendFollowUp:", error);
        showErrorToast("An error occurred while sending follow-up information");
      } finally {
        dismissLoader();
      }
    };

    const sendFollowUpViaInterrupt = async () => {
      const inputToFollowUp = {
        input: {
          patientid: pateintId,
          doctorid: doctorId,
          appointmentid: appointmentId,
          appointmentenddate: new Date().toISOString(), // current timestamp
          completed: "3",
          followup: {
            isfollowup: isScheduleFollowUp ? 1 : 0,
            followupdate:
              isScheduleFollowUp && followUpDate
                ? moment(followUpDate).format("YYYY-MM-DD")
                : null,
            isfreevisit: isFreeVisit ? 1 : 0,
            // referraldoctor: referralDoctor + ", " + referralCenter,
            referraldoctor: referralDoctor && referralCenter ? `${referralDoctor}, ${referralCenter}` : referralDoctor || referralCenter,
          },
        },
      };

      try {
        showLoader();
        // console.log("follow up", inputToFollowUp);
        handleEndVisit(); // update the appointment status
        const result = await updateDoctorNotes(inputToFollowUp.input);
        console.log(result);
        if (result) {
          showSuccessToast("Follow-up information sent successfully");
          // Open prescription page in a new tab before redirecting to visits
          const url = `/visitprescription?doctorId=${doctorId}&patientId=${pateintId}&appointmentId=${appointmentId}&fromEndVisit=${true}`;
          window.open(url, "_blank");
          // navigate("/visits");
          navigate(interruptUrl);
        } else {
          showErrorToast("Something went wrong!");
        }
      } catch (error) {
        console.error("Error in sendFollowUp:", error);
        showErrorToast("An error occurred while sending follow-up information");
      } finally {
        dismissLoader();
      }
    };

    
    const reAssignModal = useRef();
    function handleComplete (){
      reAssignModal.current.openModal();
    }
    const Submitcompleteusertask = async ()=>{
     let input = {
      "appointmentid": appointmentId,
      "doctorid": "",
      "status": 1,
      "comment": CompleteDescription
     }
     const inputForPause = {
      input: {
        doctorid: doctorId,
        appointmentid: appointmentId,
        type: "pause",
        time: new Date().toISOString(), // current timestamp
      },
    };
     try {
      showLoader();
      await UpdateAppointmentStatus(inputForPause.input);
      const result = await updateTaskComplete(input);
      console.log(result);
      if (result) {
        navigate("/visits");

      } else {
        showErrorToast("Something went wrong!");
      }
    } catch (error) {
      console.error("Error in sendFollowUp:", error);
      showErrorToast("An error occurred while sending follow-up information");
    } finally {
      dismissLoader();
    }
    }


    const hospitalChange = (e) => {
      setReferralCenter(e.target.value);
    };
    const handleHospitalChange = (value) => {
      setReferralCenter(value);
    };
    const usersChange = (e) => {
      setReferralDoctor(e.target.value);
    };
    const handleUsersChange = (value) => {
      setReferralDoctor(value);
    };
    const FetchHospitals = async() => {
      const fetchHospitalsInput = {
        doctorid: getLoginID()
      }
      showLoader();
      try{
        const result = await fetchReferredHospital(fetchHospitalsInput);
        // console.log('resutl: ', result)
        if(result && result.output.result === 'success' && result.output.data) {
          const response = result.output.data;
          const list = response?.map((item) => item.hospitalname)
          setReferralHospitalList(list)
        }else {
          setReferralHospitalList([])
        }
        dismissLoader()
      } catch(error) {
        console.error('Error in fetching the hospitals: ', error);
        throw error;
      }
    }
    const FetchDoctorUsers = async() => {
      const fetchUsersInput = {
        doctorid: getLoginID()
      }
      showLoader();
      try{
        const result = await fetchReferredDoctorUsers(fetchUsersInput);
        // console.log('resutl: ', result)
        if(result && result.output.result === 'success' && result.output.data) {
          const response = result.output.data;
          const list = response?.map((item) => item.fullname)
          setReferralUsersList(list)
        }else {
          setReferralUsersList([])
        }
        dismissLoader()
      } catch(error) {
        console.error('Error in fetching the users: ', error);
        throw error;
      }
    }

    const feedbackOpinion = useRef();
    const handleFeedbackClick = () => {
      // setPromocodeId(id);
      // setVaccinationName(name);
      if (feedbackOpinion.current) {
        feedbackOpinion.current.openModal();
      }
    };
    return (
      <>
        {screenType == "web" ? (
          <Flex
            as="nav"
            align="center"
            justify="space-between"
            wrap="wrap"
            bg="#FFFFFF"
            color="white"
            p="1rem 1.5rem"
            borderBottom="1px solid #E6E7E9"
            flexWrap='nowrap'
          >
            <Box display="flex" gap="0.5rem" alignItems="center">
              {hasImage ? (
                <Image
                  borderRadius="full"
                  w="2.75rem"
                  h="2.75rem"
                  src={patientImage}
                />
              ) : (
                <Image
                  borderRadius="full"
                  w="2.75rem"
                  h="2.75rem"
                  src="/assets/imgs/no-image.png"
                />
              )}
              <Box>
                <Text fontSize="1rem" fontWeight="600" color="black">
                  {patientName}
                </Text>
                {patientInfoId ? (
                  <Box display="flex" gap="0.25rem" alignItems="center">
                    {/* <Image src="/assets/svgs/home-calendar.svg" /> */}
                    <Text fontSize="0.75rem" fontWeight="500" color="#384052">
                      {patientInfoId} {subHeader}
                    </Text>
                  </Box>
                ) : null}
              </Box>
            </Box>
            {/* <Spacer /> */}
            <Box display="flex" gap="1rem" alignItems="center">
              {IsAssign == 1 &&
                 <PrimaryButton
                 buttonText="Complete"
                 variant="grayBtn"
                 btnStyle={{
                   bg: COLORS.PRIMARY_GRADIENT,
                   color: COLORS.PRIMARY_WHITE,
                   _hover: { bg: COLORS.PRIMARY_COLOR },
                 }}
                 onClick={handleComplete}
               />
                }
           

              <PrimaryButtonIcon
                buttonText={runningTime}
                iconSrc="/assets/svgs/time-visit.svg"
                variant="grayBtn"
                btnStyle={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  h: "2.5rem",
                  w: "8rem", // Fixed width
                  p: "1rem",
                  m: "0",
                  ml: "1rem",
                  whiteSpace: "nowrap", // Prevent text wrapping
                  overflow: "hidden", // Prevent overflow
                  textOverflow: "ellipsis", // Add ellipsis if text is too long
                }}
                textStyle={{
                  marginLeft: "auto", // Pushes the text to the right
                  marginRight: "auto", // Centers the text within the remaining space
                }}
              />

              <PrimaryButton
                buttonText={virtualVisit ? "Approve Visit" : "End/pause Visit"}
                variant="grayBtn"
                btnStyle={{ color: "red", px: "14" }}
                onClick={handlePauseEndClick}
                isDisabled={!actionAccessAppointments?.create}
              />
              {/* <PrimaryButton
                buttonText="Save As Draft"
                variant="grayBtn"
                btnStyle={{
                  h: "2.5rem",
                  w: "33%",
                  p: "0",
                  px: "6",
                  m: "0",
                  bg: COLORS.PRIMARY_GRADIENT,
                  color: COLORS.PRIMARY_WHITE,
                  _hover: { bg: COLORS.PRIMARY_COLOR },
                }}
                onClick={handleSaveAsDraft}
              /> */}
              <PrimaryButton
                // buttonText="Quick R&#x2091;"
                // buttonText="Quick Rₓ"
                buttonText={buttonText}
                variant="grayBtn"
                btnStyle={{
                  h: "2.5rem",
                  w: "25%",
                  p: "0",
                  px: "6",
                  m: "0",
                  bg: COLORS.PRIMARY_GRADIENT,
                  color: COLORS.PRIMARY_WHITE,
                  _hover: { bg: COLORS.PRIMARY_COLOR },
                }}
                onClick={handleRxButtonClick}
                // onClick={handlePrintOrder}
              />
              <PrimaryButton
                buttonText="Generate Prescription"
                variant="grayBtn"
                btnStyle={{
                  h: "2.5rem",
                  w: "33%",
                  p: "0",
                  px: "6",
                  m: "0",
                  bg: COLORS.PRIMARY_GRADIENT,
                  color: COLORS.PRIMARY_WHITE,
                  _hover: { bg: COLORS.PRIMARY_COLOR },
                }}
                onClick={handlePrintOrder}
              />
              <PrimaryButton
                buttonText="Progress Notes"
                variant="grayBtn"
                btnStyle={{
                  h: "2.5rem",
                  w: "25%",
                  p: "0",
                  px: "6",
                  m: "0",
                  bg: COLORS.PRIMARY_GRADIENT,
                  color: COLORS.PRIMARY_WHITE,
                  _hover: { bg: COLORS.PRIMARY_COLOR },
                }}
                onClick={handleProgresNotesClick}
              />
            </Box>
          </Flex>
        ) : (
          <Flex
            as="nav"
            wrap="wrap"
            gap="1rem"
            bg="#FFFFFF"
            color="white"
            p="1rem 1.5rem"
            borderBottom="1px solid #E6E7E9"
          >
            <Box display="flex" gap="0.5rem" alignItems="center" w="100%">
              {hasImage ? (
                <Image
                  borderRadius="full"
                  w="2.75rem"
                  h="2.75rem"
                  src={patientImage}
                />
              ) : (
                <Image
                  borderRadius="full"
                  w="2.75rem"
                  h="2.75rem"
                  src="/assets/imgs/no-image.png"
                />
              )}
              <Box>
                <Text fontSize="1rem" fontWeight="600" color="black">
                  {patientName}
                </Text>
                {patientInfoId ? (
                  <Box display="flex" gap="0.25rem" alignItems="center">
                    {/* <Image src="/assets/svgs/home-calendar.svg" /> */}
                    <Text fontSize="0.75rem" fontWeight="500" color="#384052">
                      {patientInfoId} {subHeader}
                    </Text>
                  </Box>
                ) : null}
              </Box>
            </Box>

            <Box
              display="flex"
              gap="1rem"
              w="100%"
              flexDir="column"
              alignItems="center"
            >
              <Box display="flex" w="100%" gap="1rem">
                <PrimaryButton
                  variant="grayBtn"
                  buttonText={runningTime}
                  btnIcon="/assets/svgs/time-visit.svg"
                  btnStyle={{ color: "#1A202C" }}
                />

                <PrimaryButton
                  buttonText="End/pause Visit"
                  variant="grayBtn"
                  btnStyle={{ color: "red", px: "14" }}
                  onClick={handlePauseEndClick}
                  isDisabled={!actionAccessAppointments?.create}
                />
              </Box>
              {/* <PrimaryButton
                buttonText="Save As Draft"
                variant="grayBtn"
                btnStyle={{
                  h: "2.5rem",
                  w: "100%",
                  p: "0",
                  px: "6",
                  m: "0",
                  bg: COLORS.PRIMARY_GRADIENT,
                  color: COLORS.PRIMARY_WHITE,
                  _hover: { bg: COLORS.PRIMARY_COLOR },
                }}
                onClick={handleSaveAsDraft}
              /> */}
            {IsAssign == 1 &&
              <PrimaryButton
                buttonText="Complete"
                variant="mdBtn"
                btnStyle={{
                  w:'100%',m:0
                }}
                onClick={handleComplete}
              />
              }
              <Flex gap='0.5rem' w='100%'>
              <PrimaryButton
                buttonText="Generate Prescription"
                variant="grayBtn"
                btnStyle={{
                  h: "2.5rem",
                  w: "100%",
                  p: "0",
                  px: "6",
                  m: "0",
                  bg: COLORS.PRIMARY_GRADIENT,
                  color: COLORS.PRIMARY_WHITE,
                  _hover: { bg: COLORS.PRIMARY_COLOR },
                }}
                onClick={handlePrintOrder}
                />
              <PrimaryButton
                buttonText="Progress Notes"
                variant="grayBtn"
                btnStyle={{
                  h: "2.5rem",
                  w: "80%",
                  p: "0",
                  px: "6",
                  m: "0",
                  bg: COLORS.PRIMARY_GRADIENT,
                  color: COLORS.PRIMARY_WHITE,
                  _hover: { bg: COLORS.PRIMARY_COLOR },
                }}
                onClick={handleProgresNotesClick}
                />
                </Flex>
            </Box>
          </Flex>
        )}

        {/* End/Pause Visit  */}
        <DynamicModal
          ref={pauseOrEndVisit}
          modalHeader="Pause/End Visit"
          modalBody={
            <>
              <Box>
                <Text fontSize="0.87rem" fontWeight="400">
                  Would you like to pause your visit or end it?{" "}
                  <Box as="span" fontWeight="500">
                    Pausing
                  </Box>{" "}
                  will allow you to continue your visit and fill in the details,
                  while{" "}
                  <Box as="span" fontWeight="500">
                    ending
                  </Box>{" "}
                  the visit will mark it as completed.
                </Text>
              </Box>
            </>
          }
          modalFooterBtn={
            <Flex
              justifyContent="center"
              alignItems="center"
              flexDirection="column"
              width="100%"
            >
              <PrimaryButton
                buttonText="End visit"
                onClick={handleEndVisit}
                mb="1rem"
                isDisabled={
                  actionAccessAppointments && actionAccessAppointments.update
                    ? false
                    : true
                }
              />
              <PrimaryButton
                buttonText="Pause visit"
                variant="grayBtn"
                btnStyle={{ w: "100%", color: COLORS.PRIMARY_COLOR }}
                onClick={handlePauseVisit}
                isDisabled={
                  actionAccessAppointments && actionAccessAppointments.create
                    ? false
                    : true
                }
              />
            </Flex>
          }
        />

        {/* End Visit  */}
        <EndVisitDynamicModal
          modalWidth={{base:'100%', lg: "50vw"}}
          ref={endVisitFollowUp}
          modalHeader={virtualVisit ? "Approve Visit" : "End visit"}
          patientId={pateintId}
          doctorId={doctorId}
          appointmentId={appointmentId}
          followUpDateForPreview={followUpDate}
          referralDoctor={referralDoctor}
          footerStyle={{py:'0.875rem'}}
          modalBody={
            <Box>
              <Flex alignItems="center" mb="1rem">
                {hasImage ? (
                  <Image
                    borderRadius="full"
                    boxSize="50px"
                    w="2.75rem"
                    h="2.75rem"
                    mr="1rem"
                    src={patientImage}
                  />
                ) : (
                  <Image
                    borderRadius="full"
                    boxSize="50px"
                    w="2.75rem"
                    h="2.75rem"
                    mr="1rem"
                    src="/assets/imgs/no-image.png"
                  />
                )}
                <Box>
                  <Text fontSize="lg" fontWeight="bold">
                    {patientName}
                  </Text>
                  <Text fontSize="sm" color="gray.500">
                    {patientInfoId}
                  </Text>
                </Box>
                <Spacer />
                <PrimaryButtonIcon
                  buttonText={runningTime}
                  iconSrc="/assets/svgs/time-visit.svg"
                  variant="grayBtn"
                  btnStyle={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    h: "2.5rem",
                    w: "8rem", // Fixed width
                    p: "1rem",
                    m: "0",
                    ml: "1rem",
                    whiteSpace: "nowrap", // Prevent text wrapping
                    overflow: "hidden", // Prevent overflow
                    textOverflow: "ellipsis", // Add ellipsis if text is too long
                  }}
                  textStyle={{
                    marginLeft: "auto", // Pushes the text to the right
                    marginRight: "auto", // Centers the text within the remaining space
                  }}
                />
              </Flex>
              <Divider my="12px" />
              <Box mb="1rem">
                {Array.from(new Set(options.map((o) => o.row))).map((row) => {
                  const rowOptions = options.filter(
                    (option) => option.row === row
                  );
                  // const columns = row < 4 ? 3 : 2;

                  return (
                    <>
                    <SimpleGrid
                      key={row}
                      columns={{base:2, md:3}}
                      spacing="1rem"
                      mb="1rem"
                    >
                      {rowOptions.map((option) => (
                        <>
                        {option.id !== 13 && (
                        <Checkbox
                          key={option.id}
                          isChecked={checkedItems[option.id] || false}
                          onChange={() => handleCheckboxChange(option.id)}
                          >
                          {option.text}
                        </Checkbox>
                          )}
                        </>
                      ))}
                    </SimpleGrid>
                  
                    {rowOptions.map((option) => (
                    option.id === 13 && option.text === "Referral to Higher Centers" && (
                  <Flex w='100%' mt='-1rem' justifyContent='space-between' gap='0.75rem'>
                      <Checkbox
                          w='100%'
                          key={option.id}
                          isChecked={checkedItems[option.id] || false}
                          onChange={() => handleCheckboxChange(option.id)}
                          >
                          {option.text}
                        </Checkbox>
                   
                 
                    {option.id === 13 && checkedItems[option.id] && option.text === "Referral to Higher Centers" && (
                    // <Box display='flex' justifyContent='flex-start'>
                    <DropdownInputForVitals
                    variant="fullSide"
                    dropDownPlace="Referral Centers"
                    options={referralHospitalList}
                    onClick={handleHospitalChange}
                    onChange={hospitalChange}
                    readOnly=""
                    inputStyleCss={{w: "100%"}}
                    inputValueProp={referralCenter}
                    menuList={{ pos: "absolute", right: "-45px", minW: "300px" }}
                    // maxLength={2}
                  />
                    // </Box>
                  )}
                
                </Flex>
                 )))}
                </>
                  );
                })}
              </Box>
              <Divider my="12px" />
              <Flex gap='1rem' alignItems='center'>
              <Checkbox
                w='100%'
                isChecked={isScheduleFollowUp}
                onChange={(e) => setIsScheduleFollowUp(e.target.checked)}
                // mb="1rem"
              >
                Schedule a follow up visit
              </Checkbox>
              
                <DropdownInputForVitals
                        variant="fullSide"
                        dropDownPlace="Referral Doctor"
                        options={referralUsersList}
                        onClick={handleUsersChange}
                        onChange={usersChange}
                        readOnly=""
                        inputStyleCss={{w: "100%"}}
                        inputValueProp={referralDoctor}
                        menuList={{ pos: "absolute", right: "-45px", minW: "300px" }}
                        // maxLength={2}
                      />
              </Flex>
              {isScheduleFollowUp && (
                <Box
                  border="1px solid #E6E7E9"
                  borderRadius="8px"
                  p="1rem"
                  mt="1rem"
                >
                  <Text fontSize="sm" mb="0.5rem">
                    Follow-up by
                  </Text>
                  <DatePicker
                    defaultDate={followUpDate}
                    onDateChange={(date) => setFollowUpDate(date)}
                    placeholderProp="Select a Date"
                    minDate={new Date().toISOString()}
                  />
                  <Checkbox
                    isChecked={isFreeVisit}
                    onChange={(e) => setIsFreeVisit(e.target.checked)}
                    mt="1rem"
                  >
                    Free visit
                  </Checkbox>
                </Box>
              )}
              
              {/* <PrimaryInput
                type="text"
                mt={"8px"}
                width={"80%"}
                variant={"bothSide"}
                inputPlace="Referral Doctor"
                defaultValue={referralDoctor}
                onChange={(e) => setReferralDoctor(e.target.value)}
              /> */}
            </Box>
          }
          modalFooterBtn={
            <Flex
              justifyContent="center"
              alignItems="center"
              flexDirection="column"
              width="100%"
            >
              <Flex w='100%' mb='0.75rem' justifyContent='flex-start'>
                <Checkbox
                  w='fit-content'
                  whiteSpace='nowrap'
                  sx={{'.chakra-checkbox__control': {w: '20px!important', h: '20px!important',borderRadius:'5px!important'}}}
                  isChecked={Esign}
                  onChange={(e) => setEsign(e.target.checked)}
                  // mb="1rem"
                  >
                  I Sign
                </Checkbox>
              </Flex>
              <Box display='flex' mb="1rem" gap='1rem' w='100%' alignItems='center'>
                  <PrimaryButton
                    buttonText={virtualVisit ? "Approve Visit" : "End visit"}
                    onClick={sendFollowUp}
                    isDisabled={
                      actionAccessAppointments && actionAccessAppointments.update && IsAssign !== 1
                      ? false
                      : true
                    }
                    />
              <PrimaryButton
                buttonText="Preview Order"
                variant="grayBtnFull"
                btnStyle={{ w: "100%", color: COLORS.PRIMARY_COLOR }}
                onClick={handlePreviewClick}
                />
              {/* <PrimaryButton
                buttonText="Feedback"
                variant="grayBtnFull"
                btnStyle={{ w: "100%", color: COLORS.PRIMARY_COLOR }}
                onClick={handleFeedbackClick}
                /> */}
              </Box>
              <>
              <Flex flexDir='column' w='100%'>
                <Text
                  textAlign={"center"}
                  fontWeight={"semibold"}
                  mb={"12px"}
                  mt={"12px"}
                >
                  OR
                </Text>

                <PrimaryButton
                  buttonText="Pause visit"
                  variant="grayBtn"
                  btnStyle={{ w: "100%", color: COLORS.PRIMARY_COLOR }}
                  onClick={handlePauseVisit}
                  isDisabled={
                    actionAccessAppointments && actionAccessAppointments.create
                      ? false
                      : true
                  }
                />
                </Flex>
              </>
            </Flex>
          }
        />

        {/* Interrupt Visit  */}
        {/* <DynamicModal
          ref={interruptVisit}
          modalHeader="Save your work"
          modalBody={
            <>
              <Box>
                <Text fontSize="0.87rem" fontWeight="400">
                  Would you like to pause your visit or save visit as a draft?{" "}
                </Text>
              </Box>
            </>
          }
          modalFooterBtn={
            <Flex
              justifyContent="center"
              alignItems="center"
              flexDirection="row"
              width="100%"
              gap="10px" // Add space between buttons
            >
              <PrimaryButton
                buttonText="Pause visit"
                onClick={handleInterruptPauseVisit}
                btnStyle={{ w: "60%", color: COLORS.PRIMARY_COLOR, ml: "2px" }}
                variant="grayBtn"
                isDisabled={
                  actionAccessAppointments && actionAccessAppointments.update
                    ? false
                    : true
                }
              />
              <PrimaryButton
                buttonText="Save as Draft"
                variant="grayBtn"
                btnStyle={{ w: "60%", color: COLORS.PRIMARY_COLOR, mr: "2px" }}
                onClick={handleInterruptSaveAsDraft}
                isDisabled={
                  actionAccessAppointments && actionAccessAppointments.update
                    ? false
                    : true
                }
              />
            </Flex>
          }
        /> */}
        <EndVisitDynamicModal
          ref={interruptVisit}
          modalHeader="End visit"
          patientId={pateintId}
          doctorId={doctorId}
          appointmentId={appointmentId}
          followUpDateForPreview={followUpDate}
          referralDoctor={referralDoctor}
          modalBody={
            <Box>
              <Flex alignItems="center" mb="1rem">
                {hasImage ? (
                  <Image
                    borderRadius="full"
                    boxSize="50px"
                    w="2.75rem"
                    h="2.75rem"
                    mr="1rem"
                    src={patientImage}
                  />
                ) : (
                  <Image
                    borderRadius="full"
                    boxSize="50px"
                    w="2.75rem"
                    h="2.75rem"
                    mr="1rem"
                    src="/assets/imgs/no-image.png"
                  />
                )}
                <Box>
                  <Text fontSize="lg" fontWeight="bold">
                    {patientName}
                  </Text>
                  <Text fontSize="sm" color="gray.500">
                    {patientInfoId}
                  </Text>
                </Box>
                <Spacer />
                <PrimaryButtonIcon
                  buttonText={runningTime}
                  iconSrc="/assets/svgs/time-visit.svg"
                  variant="grayBtn"
                  btnStyle={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    h: "2.5rem",
                    w: "8rem", // Fixed width
                    p: "1rem",
                    m: "0",
                    ml: "1rem",
                    whiteSpace: "nowrap", // Prevent text wrapping
                    overflow: "hidden", // Prevent overflow
                    textOverflow: "ellipsis", // Add ellipsis if text is too long
                  }}
                  textStyle={{
                    marginLeft: "auto", // Pushes the text to the right
                    marginRight: "auto", // Centers the text within the remaining space
                  }}
                />
              </Flex>

              <Divider my="12px" />
              <Checkbox
                isChecked={isScheduleFollowUp}
                onChange={(e) => setIsScheduleFollowUp(e.target.checked)}
                mb="1rem"
              >
                Schedule a follow up visit
              </Checkbox>
              {isScheduleFollowUp && (
                <Box
                  border="1px solid #E6E7E9"
                  borderRadius="8px"
                  p="1rem"
                  mb="1rem"
                >
                  <Text fontSize="sm" mb="0.5rem">
                    Follow-up by
                  </Text>
                  <DatePicker
                    defaultDate={followUpDate}
                    onDateChange={(date) => setFollowUpDate(date)}
                    placeholderProp="Select a Date"
                    minDate={new Date().toISOString()}
                  />
                  <Checkbox
                    isChecked={isFreeVisit}
                    onChange={(e) => setIsFreeVisit(e.target.checked)}
                    mt="1rem"
                  >
                    Free visit
                  </Checkbox>
                </Box>
              )}
              <DropdownInputForVitals
                        variant="fullSide"
                        dropDownPlace="Referral Doctor"
                        options={referralUsersList}
                        onClick={handleUsersChange}
                        onChange={usersChange}
                        readOnly=""
                        inputStyleCss={{w: "100%"}}
                        inputValueProp={referralDoctor}
                  menuList={{ pos: "absolute", right: "-45px", minW: "300px" }}
                        // maxLength={2}
                      />
              {/* <PrimaryInput
                type="text"
                mt={"8px"}
                width={"80%"}
                variant={"bothSide"}
                inputPlace="Referral Doctor"
                defaultValue={referralDoctor}
                onChange={(e) => setReferralDoctor(e.target.value)}
              /> */}
            </Box>
          }
          modalFooterBtn={
            <Flex
              justifyContent="center"
              alignItems="center"
              flexDirection="column"
              width="100%"
            >
              <PrimaryButton
                // buttonText="End visit"
                buttonText={virtualVisit ? "Approve Visit" : "End visit"}
                onClick={sendFollowUpViaInterrupt}
                mb="1rem"
                isDisabled={
                  actionAccessAppointments && actionAccessAppointments.update
                    ? false
                    : true
                }
              />
              <PrimaryButton
                buttonText="Preview Order"
                variant="grayBtn"
                btnStyle={{ w: "100%", color: COLORS.PRIMARY_COLOR }}
                onClick={handlePreviewClick}
              />

              <Text
                textAlign={"center"}
                fontWeight={"semibold"}
                mb={"12px"}
                mt={"12px"}
              >
                OR
              </Text>

              <PrimaryButton
                buttonText="Pause visit"
                variant="grayBtn"
                btnStyle={{ w: "100%", color: COLORS.PRIMARY_COLOR }}
                onClick={handlePauseVisitViaInterrupt}
                isDisabled={
                  actionAccessAppointments && actionAccessAppointments.create
                    ? false
                    : true
                }
              />
            </Flex>
          }
        />

             {/* reAssign MOdal  */}
             <DynamicModal
        ref={reAssignModal}
        modalHeader="Complete"
        modalBody={
          <>
            <Box>
            <Textarea
                      borderRadius='0'
                      placeholder="Comment"
                      defaultValue={CompleteDescription}
                      onChange={(e) =>
                        setCompleteDescription(e.target.value)
                      }
                    />
            </Box>
          </>
        }
        modalFooterBtn={
          <>
            <PrimaryButton
              buttonText="Complete"
              onClick={Submitcompleteusertask}
            />
          </>
        }
      />

<DynamicModal
        ref={feedbackOpinion}
        modalHeader="Feedback Opinion"
        modalWidth='60%'
        modalBody={
          <>
            {/* <Text fontSize="14px" fontWeight="600">
              Are you sure you want to delete?
            </Text> */}

<Flex w="100%" justifyContent="center" mt='1.5rem'>
                            <Box w="80%" p="1.5rem" 
                            // border="1px solid #E6E7E9" 
                            // borderRadius='10px' 
                            bg='white'>
                                {/* <Box
                                    gap="10px"
                                    w="100%"
                                    // pl='0'
                                    // pb='0'
                                    display="flex"
                                    alignItems='center'
                                >
                                    <Image
                                        src="/assets/imgs/arrow_back.png"
                                        w="15px" mr="5px"
                                        // onClick={backFunction}
                                        cursor='pointer'
                                    />
                                    <Text fontSize="1.25rem" fontWeight="700">
                                        Notification Details
                                    </Text>
                                </Box> */}
                                {/* <Divider my='0.75rem' /> */}
                                <Box display='flex' w='100%'>
                                    {/* <DropdownInput
                                        variant="leftSide"
                                        dropDownPlace="Type of notification*"
                                        options={['Vitals', 'Condition', 'Surgeries', 'Medication', 'Allergies', 'Others']}
                                        readOnly={true}
                                        id="Notification Type"
                                        // onClick={handletypechange}
                                        //defaultOption={NotificationType}
                                        menuList={{ pos: "absolute", right: "-45px", minW: "115px" }}
                                        inputStyleCss={{ w: "40%" }}
                                    /> */}
                                    <PrimaryInput
                                        variant="rightSide"
                                        inputPlace="Patient Name"
                                        id="title"
                                        // onChange={(e) => SetTitle(e.target.value)}
                                        // inputValue={title}
                                    />
                                </Box>

                                <Box w='100%' mt='1rem'>
                                    <Text fontSize="1rem" mb='0.5rem' fontWeight="500">Feedback<sup>*</sup></Text>
                                    <Textarea placeholder='Type your Feedback*'
                                        // onChange={(e) => SetMessageText(e.target.value)}
                                        // defaultValue={messagetext}
                                        sx={{ h: "150px", _hover: { outline: "none", } }}>
                                    </Textarea>
                                </Box>
                            </Box>
                        </Flex>
          </>
        }
        modalFooterBtn={
          <>
            <PrimaryButton
              variant="deleteBtn"
              buttonText="Save"
              // onClick={deletePromocode}
            />
          </>
        }
      />

      </>
    );
  }
);

export default PatientVisitNav;
